import { createAction } from '@reduxjs/toolkit';
import type {
  ExportReportActiveParams, ExportReportSettings,
} from '~/store/mapSettings/toolsState/exportReport/exportReportToolState.state';

export const exportReportEnable = createAction(
  'MAP_SETTINGS_EXPORT_REPORT_ENABLE',
  (params: ExportReportActiveParams) => ({
    payload: { params },
  })
);

export const exportReportDisable = createAction(
  'MAP_SETTINGS_EXPORT_REPORT_DISABLE',
);

export const exportReportSetSettings = createAction(
  'MAP_SETTINGS_EXPORT_SET_SETTINGS',
  (settings: ExportReportSettings) => ({
    payload: { settings },
  })
);
